export default __webpack_public_path__ + "static/media/mounika.png.webp";